import React from "react";
import { useRouter } from "next/router";
import { GuideLinesPageContent } from "./AppTemplate";
import useDisableIntercom from "@/hooks/useDisableIntercom";
import MainTemplate from "@/components/Templates/MainTemplate";

function CommunityGuideLines() {
  const location = useRouter();

  const queryParser = location?.query;
  const isFromAppSource = queryParser?.source === "app";

  useDisableIntercom({ hideIntercom: isFromAppSource });

  return (
    <MainTemplate hideFooter={isFromAppSource} hideHeader={isFromAppSource}>
      <GuideLinesPageContent webMode={!isFromAppSource} />
    </MainTemplate>
  );
}

export default CommunityGuideLines;
